import { useEffect } from 'react';
import { cmsAPI } from '../utils/api';

export default function GoogleAnalytics() {
  useEffect(() => {
    const controller = new AbortController();
    cmsAPI.siteConfig({ signal: controller.signal }).then(({ data }) => {
      const measurementId = data.data?.google_analytics?.enabled ? data.data.google_analytics.measurement_id : null;
      if (!measurementId || document.querySelector(`script[data-ga4="${measurementId}"]`)) return;

      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag(){ window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
      window.gtag('config', measurementId, { anonymize_ip: true });

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
      script.dataset.ga4 = measurementId;
      document.head.appendChild(script);
    }).catch((error) => {
      if (error.code !== 'ERR_CANCELED') console.error('Unable to load site analytics config.');
    });

    return () => controller.abort();
  }, []);

  return null;
}
